"use strict";
exports.__esModule = true;
exports.DiscardDialog = void 0;
var tslib_1 = require("tslib");
var styles_1 = require("@material-ui/core/styles");
var react_1 = tslib_1.__importStar(require("react"));
var Button_1 = require("../Button");
var Dialog_1 = require("../Dialog");
var Icon_1 = require("../Icon");
var useStyles = styles_1.makeStyles(function (theme) { return ({
    body: {
        padding: '1.5rem 1.5rem',
        position: 'absolute',
        inset: 0,
        background: '#EDF2F7',
        overflowY: 'scroll'
    },
    noWrap: {
        whiteSpace: 'nowrap'
    },
    error: {
        backgroundColor: theme.palette.error.main,
        color: theme.palette.error.contrastText
    },
    discardDialogHeader: {
        '& > h2': {
            display: 'flex',
            alignItems: 'center'
        }
    },
    discardDialogTitle: { marginLeft: '1rem' },
    discardDialogContent: { margin: '0 0 0 2.3rem' }
}); });
exports.DiscardDialog = react_1.memo(function (_a) {
    var _b, _c, _d, _e;
    var open = _a.open, onClose = _a.onClose, handleDiscard = _a.handleDiscard, locales = _a.locales;
    var classes = useStyles({ responsive: false, size: 'small' });
    return (react_1["default"].createElement(Dialog_1.Dialog, { "aria-describedby": "dialog-description", "aria-labelledby": "dialog-title", maxWidth: "sm", onClose: onClose, open: open },
        react_1["default"].createElement(Dialog_1.DialogTitle, { className: classes.discardDialogHeader },
            react_1["default"].createElement(Icon_1.EIcon, { color: "error", fontSize: "small", name: "trash" }),
            react_1["default"].createElement("span", { className: classes.discardDialogTitle }, (_b = locales.discardChangesDialog) === null || _b === void 0 ? void 0 : _b.title)),
        react_1["default"].createElement(Dialog_1.DialogContent, null,
            react_1["default"].createElement(Dialog_1.DialogContentText, { className: classes.discardDialogContent }, (_c = locales.discardChangesDialog) === null || _c === void 0 ? void 0 : _c.message)),
        react_1["default"].createElement(Dialog_1.DialogActions, null,
            react_1["default"].createElement(Button_1.Button, { className: classes.noWrap, onClick: onClose, variant: "outlined" }, (_d = locales.discardChangesDialog) === null || _d === void 0 ? void 0 : _d.cancelButtonLabel),
            react_1["default"].createElement(Button_1.Button, { className: classes.error + " " + classes.noWrap, onClick: handleDiscard, variant: "contained" }, (_e = locales.discardChangesDialog) === null || _e === void 0 ? void 0 : _e.confirmButtonLabel))));
});
exports.DiscardDialog.displayName = 'DiscardDialog';
//# sourceMappingURL=DiscardDialog.js.map